// @ts-check
import { log } from '../utils/console.js';
import * as http from '../utils/http.js';

export function createCartV1dot11(url, requestData) {
  return sendRequest('POST', url, requestData);
}

export function transferCartV1dot11(url, requestData) {
  return sendRequest('POST', url, requestData);
}

/**
 * @deprecated Use `http` directly
 * @param {string} method
 * @param {string} url
 * @param {Object} params
 */
export function sendRequest(method, url, params) {
  log.info(`Service - send request. url: ${url}`);

  return http[method](url, params);
}
